import { ref, get, set, onValue, off } from 'firebase/database';
import { rtdb } from '../../config/firebase';

const PATH = 'settings';

type Unsubscribe = () => void;

export const getFamilyBookingInfo = async (): Promise<string> => {
  const snapshot = await get(ref(rtdb, `${PATH}/familyBookingInfo`));
  return snapshot.exists() ? (snapshot.val() as string) : '';
};

export const saveFamilyBookingInfo = async (text: string): Promise<void> => {
  await set(ref(rtdb, `${PATH}/familyBookingInfo`), text);
};

export const subscribeToFamilyBookingInfo = (
  callback: (text: string) => void,
  onError?: (error: Error) => void
): Unsubscribe => {
  const r = ref(rtdb, `${PATH}/familyBookingInfo`);
  const handler = onValue(
    r,
    (snapshot) => callback(snapshot.exists() ? (snapshot.val() as string) : ''),
    onError
  );
  return () => off(r, 'value', handler);
};
